import React, { lazy, Suspense, useState } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.css';

import { initUserObject, checkUserToken } from './helpers/AuthUserHelper';
import { initOwnerObject, isOwnerStatusValid } from './helpers/AuthOwnerHelper';
import UserContext from './context/UserContext';
import OwnerContext from './context/OwnerContext';
import Spinner from './components/Spinner';
import OwnerConsentsPage from './pages/OwnerConsentsPage';
import OwnerLoginPage from './pages/OwnerLoginPage';
import LoginPage from './pages/LoginPage';
import ErrorPage from './pages/ErrorPage';
import UnauthorisedPage from './pages/UnauthorisedPage';
import PageNotFound from './pages/PageNotFound';

const RevokeLandingPage = lazy(() => import('./pages/RevokeLandingPage'));
const AdvertiserPage = lazy(() => import('./pages/AdvertiserPage'));
const SupplierPage = lazy(() => import('./pages/SupplierPage'));
const ProcessorPage = lazy(() => import('./pages/ProcessorPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));



function App() {
  const [ loginUser, setLoginUser ] = useState<object | null>(null);
  const [ isLoginUserSet, setIsLoginUserSet ] = useState<boolean>(false);
  const [ ownerStatus, setOwnerStatus ] = useState<object | null>(null);
  const [ isOwnerStatusSet, setIsOwnerStatusSet ] = useState<boolean>(false);
  
  
  checkUserToken({ loginUser, setLoginUser });
  if (!isLoginUserSet) {
    initUserObject(setLoginUser);
    setIsLoginUserSet(true);
  }

  isOwnerStatusValid({ ownerStatus, setOwnerStatus });
  if (!isOwnerStatusSet) {
    initOwnerObject(setOwnerStatus);
    setIsOwnerStatusSet(true);
  }


  return (
    <div className="page-container">
        <HashRouter>
          <OwnerContext.Provider value={ { ownerStatus: ownerStatus, setOwnerStatus: setOwnerStatus } } >
          <UserContext.Provider value={ { loginUser: loginUser, setLoginUser: setLoginUser } } >
            <Switch>
              <Route path="/consents" exact render={() => <OwnerConsentsPage />}/>
              <Route path="/" exact render={() => <OwnerLoginPage />}/>
              <Route path="/mitsamtykke" exact render={() => <OwnerLoginPage />}/>
              <Route path="/error" exact render={() => <ErrorPage /> } />
              <Route path="/unauth" exact render={() => <UnauthorisedPage /> } />
              <Route path="/user/login" render={() => <LoginPage /> } />
              <Suspense fallback={<Spinner />}>
                <Switch>
                  <Route path="/r/:segment" exact component={RevokeLandingPage}/>
                    <Route path="/advertiser" render={() => <AdvertiserPage /> } />
                    <Route path="/processor" render={() => <ProcessorPage /> } />
                    <Route path="/supplier" render={() => <SupplierPage /> } />
                    <Route path="/admin" render={() => <AdminPage /> } />
                    <Route path="*" render={() => <PageNotFound /> } />
                </Switch>
              </Suspense>
            </Switch>
          </UserContext.Provider>
          </OwnerContext.Provider>
        </HashRouter>
    </div>
  );
}

export default App;
